import {Box, SvgIcon, SvgIconProps} from "@mui/material";
import {UsersIconProps} from "./UsersIcon";

export interface UsageIconProps extends SvgIconProps {
    scolor?: string;
}

const UsageIcon = ({ scolor = "#78909C", ...props }: UsageIconProps) => {
    return (
        <SvgIcon style={{fill: "none"}} {...props}

        sx={{
        cursor: "pointer",
        "& g": {
          fill: scolor,
          transition: "fill 0.2s",
        },
        "&:hover g": {
          fill: "white",
        },
      }}
        >
            <path d="M0 0h24v24H0V0"/>
            <g>
                <path
                    d="M3.868 4.068C5.924 2.249 9.83 2.474 12 5.655c2.17-3.18 6.082-3.405 8.14-1.53.931.835 1.555 2.19 1.772 3.685a8.7 8.7 0 0 1-.722 4.88c-1.28 2.768-3.521 4.846-5.396 6.218a23.4 23.4 0 0 1-2.44 1.562 18.94 18.94 0 0 1-.753.398c-.091.045-.163.079-.212.102l-.058.027-.017.008-.005.002v.001h-.002a.75.75 0 0 1-.619-.002l.312-.682-.313.682h-.002c0-.002-.003-.002-.004-.003l-.017-.008a7.527 7.527 0 0 1-.269-.132c-.18-.09-.438-.225-.753-.403a23.78 23.78 0 0 1-2.439-1.579c-1.874-1.384-4.113-3.475-5.394-6.242v-.002a8.806 8.806 0 0 1-.721-4.903c.203-1.402.764-2.679 1.607-3.506l.173-.16Zm7.445 3.43C9.77 4 6.325 3.891 4.858 5.194l-.006.005c-.59.513-1.097 1.49-1.28 2.75a7.304 7.304 0 0 0 .599 4.059l.221.452c1.16 2.227 3.036 3.982 4.703 5.213a22.29 22.29 0 0 0 2.282 1.48c.254.143.467.254.625.334.157-.079.37-.188.625-.33a21.932 21.932 0 0 0 2.281-1.46c1.777-1.3 3.792-3.198 4.921-5.64l.113-.255a7.194 7.194 0 0 0 .486-3.777c-.183-1.257-.69-2.248-1.288-2.784l-.006-.004c-1.464-1.34-4.904-1.239-6.448 2.26a.75.75 0 0 1-1.373 0Z"/>
                <path
                    d="M13.953 8.215a.75.75 0 0 1 .671.333l1.777 2.666h4.26a.75.75 0 0 1 0 1.5H16a.75.75 0 0 1-.624-.334l-1.283-1.925L11.67 15.3a.751.751 0 0 1-1.201.195l-2.78-2.78H3.34a.75.75 0 0 1 0-1.5H8l.146.014a.75.75 0 0 1 .384.206l2.264 2.263 2.535-5.068.05-.086a.75.75 0 0 1 .574-.328Z"/>
            </g>
        </SvgIcon>
    );
};

export default UsageIcon;